var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import i18next from 'i18next';
import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'qs';
import { name } from '~slices/auth/constants';
import { executeRequest } from '~utils/executeRequest';
import { getGmtTimezone } from '~utils/gmtTimezone';
import { refreshTokenSelector } from '~slices/auth/selectors';
var CLIENT_ID = process.env.REACT_APP_CLIENT_ID || '';
var CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET || '';
var BASE_URL = process.env.REACT_APP_BASE_URL || '';
var getMilliseconds = function (seconds) { return seconds * 1000; };
var makeExpiresAtFromExpiresIn = function (expiresIn) {
    return getMilliseconds(expiresIn) + Date.now();
};
var getAuthStateData = function (data) { return ({
    accessToken: data.access_token || null,
    refreshToken: data.refresh_token || null,
    expiresAt: makeExpiresAtFromExpiresIn(Number(data.expires_in)),
    userId: data.externalId,
}); };
export var login = createAsyncThunk("".concat(name, "/login"), function (requestData, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var queryString, response, errorData, data, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    queryString = qs.stringify(__assign(__assign({}, requestData), { grant_type: 'password' }));
                    return [4 /*yield*/, fetch("".concat(BASE_URL, "auth/v1/oauth/token/beton?client_id=").concat(CLIENT_ID, "&client_secret=").concat(CLIENT_SECRET, "&timezone=").concat(getGmtTimezone(true), "&app_version=").concat(process.env.REACT_APP_VERSION), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            credentials: 'include',
                            body: queryString,
                        })];
                case 1:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    errorData = _b.sent();
                    return [2 /*return*/, rejectWithValue(errorData)];
                case 3: return [4 /*yield*/, response.json()];
                case 4:
                    data = _b.sent();
                    return [2 /*return*/, getAuthStateData(data)];
                case 5:
                    error_1 = _b.sent();
                    throw new Error('Unexpected error during login');
                case 6: return [2 /*return*/];
            }
        });
    });
});
export var getCookieAccepatation = createAsyncThunk("".concat(name, "/getCookieAccepatation"), function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var errorResult, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorResult = null;
                    return [4 /*yield*/, executeRequest({
                            url: 'player/v1/cookie-accept',
                            options: {
                                method: 'GET',
                                credentials: 'include',
                            },
                            setError: function (err) {
                                errorResult = err;
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!response || !('data' in response) || 'error' in response) {
                        return [2 /*return*/, rejectWithValue(errorResult)];
                    }
                    return [2 /*return*/, response.data];
            }
        });
    });
});
export var setCookieAccepatation = createAsyncThunk("".concat(name, "/setCookieAccepatation"), function (_, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var errorResult, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorResult = null;
                    return [4 /*yield*/, executeRequest({
                            url: 'player/v1/cookie-accept',
                            options: {
                                method: 'POST',
                                credentials: 'include',
                            },
                            setError: function (err) {
                                errorResult = err;
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!response || !('data' in response) || 'error' in response) {
                        return [2 /*return*/, rejectWithValue(errorResult)];
                    }
                    return [2 /*return*/, response.data || {}];
            }
        });
    });
});
export var registration = createAsyncThunk("".concat(name, "/registration"), function (_a, _b) { return __awaiter(void 0, void 0, void 0, function () {
    var errorResult, response;
    var recaptchaToken = _a.recaptchaToken, requestData = __rest(_a, ["recaptchaToken"]);
    var rejectWithValue = _b.rejectWithValue;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                errorResult = null;
                return [4 /*yield*/, executeRequest({
                        url: 'auth-service/v1/users',
                        options: {
                            method: 'POST',
                            headers: {
                                lang: i18next.language,
                                timezone: getGmtTimezone(false),
                                'recaptcha-token': recaptchaToken,
                            },
                        },
                        bodyData: requestData,
                        setError: function (err) {
                            errorResult = err;
                        },
                    })];
            case 1:
                response = _c.sent();
                if (!response || !('data' in response) || 'error' in response) {
                    // @ts-expect-error
                    return [2 /*return*/, rejectWithValue(errorResult)];
                }
                return [2 /*return*/, response.data];
        }
    });
}); });
export var resendEmail = createAsyncThunk("".concat(name, "/resendEmail"), function (values, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var errorResult, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorResult = null;
                    return [4 /*yield*/, executeRequest({
                            url: "auth/v1/users/confirm/registration/resend".concat(values.isOldEmail ? "/".concat(values.externalId) : ''),
                            options: {
                                method: values.isOldEmail ? 'GET' : 'POST',
                            },
                            bodyData: values.isOldEmail
                                ? undefined
                                : values,
                            setError: function (err) {
                                errorResult = err;
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!response || !('data' in response) || 'error' in response) {
                        return [2 /*return*/, rejectWithValue(errorResult)];
                    }
                    return [2 /*return*/, response.data];
            }
        });
    });
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var cachedRefreshPromise = null;
export var refresh = createAsyncThunk("".concat(name, "/refresh"), function (_, _a) {
    var getState = _a.getState, rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var refreshToken, body, url, refreshPromise;
        return __generator(this, function (_b) {
            if (cachedRefreshPromise) {
                return [2 /*return*/, cachedRefreshPromise];
            }
            refreshToken = refreshTokenSelector(getState());
            if (!refreshToken) {
                return [2 /*return*/, rejectWithValue({
                        error: 'NO_REFRESH_TOKEN',
                        message: 'No refresh token provided',
                        status: 400,
                        timestamp: new Date().toISOString(),
                        path: '/auth/v1/oauth/token/beton',
                        errors: [],
                    })];
            }
            body = new URLSearchParams({
                refresh_token: refreshToken,
                grant_type: 'refresh_token',
            });
            url = "".concat(BASE_URL, "auth/v1/oauth/token/beton?client_id=").concat(CLIENT_ID, "&client_secret=").concat(CLIENT_SECRET, "&timezone=").concat(getGmtTimezone(true));
            refreshPromise = fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: body.toString(),
                credentials: 'include',
            })
                .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                var errorData, data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!response.ok) return [3 /*break*/, 2];
                            return [4 /*yield*/, response.json()];
                        case 1:
                            errorData = _a.sent();
                            return [2 /*return*/, rejectWithValue(errorData)];
                        case 2: return [4 /*yield*/, response.json()];
                        case 3:
                            data = _a.sent();
                            return [2 /*return*/, getAuthStateData(data)];
                    }
                });
            }); })
                .catch(function (error) {
                throw error;
            })
                .finally(function () {
                cachedRefreshPromise = null;
            });
            cachedRefreshPromise = refreshPromise;
            return [2 /*return*/, refreshPromise];
        });
    });
});
export var checkRegistrationData = createAsyncThunk('checkRegistrationData', function (values, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var errorResult, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorResult = null;
                    return [4 /*yield*/, executeRequest({
                            url: 'auth/v1/users/field/validate',
                            options: {
                                method: 'POST',
                            },
                            bodyData: values,
                            setError: function (err) {
                                errorResult = err;
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!response || !('data' in response) || 'error' in response) {
                        return [2 /*return*/, rejectWithValue(errorResult)];
                    }
                    return [2 /*return*/, response.data];
            }
        });
    });
});
export var checkForUpdateEmail = createAsyncThunk('checkUpdatedEmail', function (value, _a) {
    var rejectWithValue = _a.rejectWithValue;
    return __awaiter(void 0, void 0, void 0, function () {
        var errorResult, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    errorResult = null;
                    return [4 /*yield*/, executeRequest({
                            url: 'rule/v1/rules/validate/update/email',
                            options: {
                                method: 'PUT',
                            },
                            bodyData: value,
                            setError: function (err) {
                                errorResult = err;
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!response || !('data' in response) || 'error' in response) {
                        return [2 /*return*/, rejectWithValue(errorResult)];
                    }
                    return [2 /*return*/, response.data];
            }
        });
    });
});
